/**
 * Force lazy-loaded chunks to load from the site origin root (/static/js/...), not from the
 * current URL path (e.g. /sales/static/...). Without this, homepage"."or webpack"auto"* publicPath breaks code-splitting on deep client routes.
 *
 * Skip on Electron and file:// (desktop build uses relative PUBLIC_URL).
 */
declare let __webpack_public_path__: string

const w = typeof window !== 'undefined' ? window : undefined
const isElectron = Boolean((w as Window & { electronAPI?: { isElectron?: boolean } })?.electronAPI?.isElectron)
const isHttp = Boolean(w?.location?.protocol?.startsWith('http'))

if (w && isHttp && !isElectron) {
 __webpack_public_path__ = `${w.location.origin}/`
 void __webpack_public_path__
}

export {}
